import ACTIONS from "../../constants/constants"

export const makFabric = (state = null, action) => {
  const {type, payload} = action

  switch (type) {
    case ACTIONS.CREATE_CANVAS_API:
      return {
        ...payload,
      }
    case ACTIONS.CLEAR_CANVAS_API:
      return null
    default:
      return state
  }
}
